// extracted by mini-css-extract-plugin
export default {"viseme-rive-container":"VisemeAnimation_viseme-rive-container__EnIrr","display-box":"VisemeAnimation_display-box__gQkYo"};